import Vue from 'vue';
const user = {
  state: {
    img: '',
    nickname: '',
    userInfo: {},
  },
  mutations: {
    SET_IMG: (state, img) => {
      state.img = img;
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
  },

  actions: {
    setUserInfo({ commit }, type) {
      commit('SET_USER_INFO', type);
    },
  },
};

export default user;
